import { MemreFlexBox } from 'components/core';
import Video from '../Video';

export default function VideoBlock({ item }) {
  const handleAddVideo = async (url, videoId) => {
    try {
      await item.addVideo(url, videoId);
    } catch (error) {
      console.error('Error adding video:', error);
    }
  };

  return (
    <MemreFlexBox
      direction="column"
      gap={1}
      justify="center"
      align="center"
      sx={{
        p: 4,
        flex: 1,
        width: '100%',
        maxWidth: '500px',
        margin: '0 auto',
      }}
    >
      <Video url={item.url} add={handleAddVideo} />
    </MemreFlexBox>
  );
}